module.exports = __webpack_public_path__ + "static/media/01.2a8279e3.webp";